<template>
  <noData />
  <!-- <div v-if="Object.keys(detail).length == 0" class="my-line">
    <img class="no-patient-pic" src="~@/assets/images/no-content.png" alt="">
    <p>暂无排队记录</p>
  </div>
  <div v-else style="position: relative">
    <div style="z-index: 100; positon: absolute" class="bcStyle">
      <div
        style="display: flex; justify-content: space-around; margin-top: 20px"
      >
        <div class="patientStyle">姓名:{{ detail.name }}</div>
        <div class="patientStyle">性别：{{ detail.sex }}</div>
      </div>
    </div>

    <div class="lineDetail">
      <div style="margin-top: 20px">
        <div class="deptName">就诊科室</div>
        <div class="deptStyle">{{ detail.deptName }}</div>
      </div>

      <div style="margin-top:80px">
        <div class="oder">就诊序号</div>
        <div class="odrStyle">{{ detail.order }}</div>
        <div class="num" style="margin-top:20px">您前面还有
          <span style="font-color:red">{{ detail.number }}</span>
          人在排队</div>
        <div class="num" style="margin-top:-20px">请耐心等待</div>
      </div>
    </div>
  </div> -->
</template>

<script>
export default {
  name: 'MyLine',
  data() {
    return {
      detail: {
        name: '',
        sex: ' ',
        deptName: ' ',
        order: '',
        number: ''
      }
    }
  },
  created() {},
  mounted() {},
  methods: {}
}
</script>
<style rel="stylesheet/less" lang="less" scoped>
.my-line {
  text-align: center;
  margin-top: 1rem;
  p {
    line-height: 1rem;
  }
}
.odrStyle{

font-size: 70px;
font-family: PingFang SC, PingFang SC-Bold;
font-weight: 700;
text-align: center;
color: #020114;

}
.num{

font-size: 25px;
font-family: PingFang SC, PingFang SC-Medium;
font-weight: 500;
text-align: center;
color: #555555;
line-height: 59px;
letter-spacing: 2.28px;
}

.oder{

font-size: 25px;
font-family: PingFang SC, PingFang SC-Medium;
font-weight: 400;
text-align: center;
color: #555555;
line-height: 40px;
letter-spacing: 0.16px;
}
.bcStyle {
  width: 100%;

  position: absolute;
  height: 200px;

  background: url("../../assets/images/blueBc.png") no-repeat;

  background-size: cover;
}

.lineDetail {
  margin-left: 11px;
  width: 95%;
  // margin-top:-90px;
  z-index: 1000;
  position: absolute;
  height: 400px;
  margin-top: 70px;
  background: url("../../assets/images/linePage.png") no-repeat;

  background-size: cover;
}

.patientStyle {
  height: 32px;
  font-size: 20px;

  font-weight: 500;
  text-align: center;
  color: #ffffff;
}

.deptName {
  font-size: 20px;

  font-weight: 500;
  text-align: center;
  color: #555555;
  line-height: 40px;
  letter-spacing: 0.16px;
}
.deptStyle {
  font-size: 35px;
  font-family: PingFang SC, PingFang SC-Bold;
  font-weight: 700;
  text-align: center;
  color: #f07a43;
}
</style>
